import { useState } from "react";
import { Modal } from "react-bootstrap";
import { BaseURL } from "../../../constants/enum/baseURL.emum";

const GenReportDoc3 = (props: { sche: number }) => {
  const { sche } = props;
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);

  return (
    <>
      <a
        className="btn  btn-primary"
        href={`${BaseURL.BASE_URL}/testreport/${sche}`}
        target="_blank"
        rel="noreferrer"
      >
        รายงานการส่ง
      </a>
      {/* <button className="btn  btn-primary ms-1" onClick={handleShow}>
        รายงารการส่ง
      </button> */}
      <Modal
        show={show}
        onHide={handleClose}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        // centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">เอกสาร</Modal.Title>
        </Modal.Header>{" "}
        <Modal.Body>
          <iframe
            className="container-fluid"
            src={encodeURI(`${BaseURL.BASE_URL}/genreport/${sche}`)}
            style={{ height: "100vh" }}
            title="รายงานการส่ง"
          ></iframe>
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            className="btn btn-danger"
            onClick={handleClose}
          >
            Close
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default GenReportDoc3;
